module.exports = __webpack_public_path__ + "img/mercedes-benz-g-2022-300x198.14ab8f5a.jpg";